<script>
/* eslint-disable no-unused-vars */
const General = () => import('./components/index.vue')
import dataView from 'src/modules/pages/view'
import contentPage from './components/index'

export default {
  mixins: [dataView],
  name: "mekas",
  data() {
    return {
      route: 'Mekas',
    }
  },
  components: {
    'contentPage' : contentPage
  }
}
</script>
